module.exports = "/_next/static/images/cbf49577e11c5507dbd0019319ae8a66-kit-logo.png";